declare global {
  interface Window {
    Telegram?: {
      WebApp?: {
        initData: string;
        initDataUnsafe: {
          user?: {
            id: number;
            first_name: string;
            last_name?: string;
            username?: string;
            photo_url?: string;
          };
          auth_date?: number;
        };
        ready(): void;
        expand(): void;
        close(): void;
        MainButton: {
          text: string;
          show(): void;
          hide(): void;
          onClick(cb: () => void): void;
          offClick(cb: () => void): void;
        };
        BackButton: {
          show(): void;
          hide(): void;
          onClick(cb: () => void): void;
          offClick(cb: () => void): void;
        };
        HapticFeedback: {
          impactOccurred(style: "light" | "medium" | "heavy" | "rigid" | "soft"): void;
          notificationOccurred(type: "error" | "success" | "warning"): void;
          selectionChanged(): void;
        };
        themeParams: {
          bg_color?: string;
          text_color?: string;
          hint_color?: string;
          link_color?: string;
          button_color?: string;
          button_text_color?: string;
          secondary_bg_color?: string;
        };
        colorScheme: "light" | "dark";
        version: string;
        platform: string;
      };
    };
  }
}

const tg = window.Telegram?.WebApp;

export const isTelegram: boolean = !!(tg && tg.initData);

export function tgReady(): void {
  if (!tg) return;
  tg.ready();
}

export function tgExpand(): void {
  if (!tg) return;
  tg.expand();
}

export function getTelegramUser(): { id: number; firstName: string } | null {
  if (!tg?.initDataUnsafe?.user) return null;
  const u = tg.initDataUnsafe.user;
  return { id: u.id, firstName: u.first_name };
}

export function getTelegramInitData(): string {
  return tg?.initData ?? "";
}

export function tgHaptic(
  type: "jump" | "collect" | "death" | "ui"
): void {
  if (!tg?.HapticFeedback) return;
  switch (type) {
    case "jump":
      tg.HapticFeedback.impactOccurred("light");
      break;
    case "collect":
      tg.HapticFeedback.impactOccurred("medium");
      break;
    case "death":
      tg.HapticFeedback.notificationOccurred("error");
      break;
    case "ui":
      tg.HapticFeedback.selectionChanged();
      break;
  }
}

export function tgShowBackButton(show: boolean): void {
  if (!tg?.BackButton) return;
  if (show) tg.BackButton.show();
  else tg.BackButton.hide();
}

export function tgOnBackButton(cb: () => void): void {
  if (!tg?.BackButton) return;
  tg.BackButton.onClick(cb);
}

export function tgOffBackButton(cb: () => void): void {
  if (!tg?.BackButton) return;
  tg.BackButton.offClick(cb);
}

export function applyTelegramMode(): void {
  if (!isTelegram) return;
  document.body.classList.add("tg-mode");
  tgReady();
  tgExpand();
}

export {};
